export enum EPlatform {
  'MPWX' = 'mp-wx',
  'WEB' = 'web',
}

export type TPlatform = EPlatform.MPWX | EPlatform.WEB;
